import { Handle, Position } from "reactflow";
import { Button } from "@components/Input";

import "./ButtonAddExtension.scss";
import { useFlowNodes } from "views/Bots/NLP/application/Build/Flow/context";
import { addNodeExtension } from "../../../../../utils/addNode";
import { typesNodes } from "views/Bots/NLP/application/Build/Flow/types/nodeTypes/typesNodes";

export const ButtonAddExtension = (dataNode, id) => {
  const { t, setNodes, setEdges, updateElement } = useFlowNodes();

  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div>
        <Button
          className="btn_add_node"
          onClick={(e) => {
            updateElement(e, "extension", "add");
            addNodeExtension({
              setNodes,
              setEdges,
              dataNode: dataNode,
              type: typesNodes.extensionConfig,
              offsetX: 207,
              offsetY: -184.5,
            });
          }}
          text={` ${t("intents.config.accordion.extensions.empty.button")}`}
        />
      </div>
    </>
  );
};
